class ObjetoConId {

    constructor(id){
        this.id= id
    }

}

export {ObjetoConId as default}